/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

const ChannelType = Object.freeze({
  ELECTRICITY:      0,
  APPLIANCE:        1,
  ELECTRICITY_SPUR: 2,
  CALCULATED:       3,
  GAS:              4,
  GAS_SPUR:         5,
  WATER:            6,
  WATER_SPUR:       7,
  TEMPERATURE:      8,
  BINARY:           9,
} as const);

export default ChannelType;
